import Model from '@/models/Model'

export default class HrHealthAffiliation extends Model {
    resource() {
        return 'hr_health_affiliation'
    }
}